import React, { Component } from 'react'
import moment from 'moment'

class Footer extends Component {
  render() {
    return (
      <footer className="app-footer">
        <div>
          <a className="nav-link pull-left" aria-current="false"
            href="https://www.youtube.com/channel/UCwRpyYRqqk0KqDEvUV9IM2Q" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-youtube fa-lg" />
          </a>
          <a className="nav-link pull-left" aria-current="false"
            href="https://www.facebook.com/weldinGo/" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-facebook fa-lg" />
          </a>
          <a className="nav-link pull-left" aria-current="false"
            href="https://www.linkedin.com/company/weldingo/" rel="noopener noreferrer" target="_blank">
            <i className="fa fa-linkedin fa-lg" />
          </a>
        </div>
        <span className="ml-auto">Powered by &copy;<a href="http://www.weldingo.com"> weldinGo </a>{moment().format('YYYY')}</span>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js